<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import PrintOptions from "@/components/modals/print-options.vue";
import ApiResourceLogs from "@/components/modals/api-resource-logs.vue";
import ResourceDetails from "@/components/modals/resource-details.vue";
import Swal from "sweetalert2";
import RawData from "@/components/widgets/raw-data.vue";

export default {
    page: {
        title: "List of Procurables",
    },
    components: {
        Layout,
        PageHeader,
        PrintOptions,
        ApiResourceLogs,
        ResourceDetails,
        RawData
    },
    data() {
        return {
            title: "Procurables",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Procurables",
                    active: true,
                },
            ],
            tableData: [],
            searchData: [],
            modalTitle: "",
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: "",
            filterOn: [],
            sortBy: "",
            sortDesc: false,
            fields: [
                {
                    key: "office",
                    sortable: true,
                },
                {
                    key: "name",
                    sortable: true,
                    label: "API Name",
                    thStyle: { width: "48%" },
                },
                {
                    key: "totalAmt",
                    sortable: true,
                    label: "Total Amount",
                    thStyle: { width: "20%", textAlign: "center" },
                },
                {
                    key: "item",
                    sortable: true,
                    label: "Items",
                    thStyle: { width: "180px" },
                },
            ],
            indexSelected: -1,
            tableBusy: false,
            searchHit: false,
            totalProcurables: 0,
            procurableCount: 0,
            groupedData: [],
            procurableStatus: 2,
            dus: [],
            mixStatus: 2
        };
    },
    computed: {
        rows() {
            if (this.filter) {
                return this.totalRows;
            }
            return this.tableData.length;
        },
        filteredUnallowed(){
            let data = this.groupedData;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.searchList
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            return data;
        },
        filteredDU(){
            let data = this.dus;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            return data;
        }
    },
    async created() {
        this.totalRows = this.items.length;
        this.changeStatus(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
    },
    methods: {
        async changeCycle(cycle) {
            this.changeStatus(cycle, this.$store.state.data.selectedCampus.id);
        },
        async changeCampus(campusId) {
            this.changeStatus(this.$store.state.data.cycle, campusId);
        },
        onFiltered(filteredSuppliers) {
            this.totalRows = filteredSuppliers.length;
            this.currentPage = 1;
        },
        async getDUs(campusId){
            this.tableBusy = true;
            this.dus = []
            await this.$store
                .dispatch("deliveryunit/GetDeliveryUnitByCampus", campusId)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(x => {
                        x.rotateChevy = false;
                        x.filterKey = x.name;
                        x.apis = [];
                        x.loadingApi= false;
                    })
                    this.dus = res.data;
                })
                .catch((err) => {
                    this.showToast("Something went wrong", "error");
                });
            this.tableBusy = false;
        },
        async getApis(du){
            du.rotateChevy = !du.rotateChevy;
            if(du.apis.length == 0 && du.rotateChevy){
                du.loadingApi = true;
                await this.$store
                    .dispatch("api/GetApprovedProcurable", {deliveryUnitId: du.id, cycle: this.$store.state.data.cycle})
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        res.data.map(x => {
                            x._showDetails = false;
                            x.apiResourcesLoading = false;
                            x.apiResources = [];
                        })
                        du.apis = res.data;
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong", "error");
                    });
                du.loadingApi = false;
            }
        },
        getInitialItems(cycle, campusId) {
            this.groupedData = [];
            this.tableData = [];
            this.tableBusy = true;
            this.$store
                .dispatch("procurable/GetProcurableSummary", {
                    cycle,  
                    campusId,
                    mixStatus: this.mixStatus
                })
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        item.rotateChevy = false;
                        item.searchList = `${item.name}`;
                        item.data = [];
                        item.apiLoading = false;
                    })
                    this.tableBusy = false;
                    this.procurableCount = res.data.length;
                    this.groupedData = res.data;
                    this.tableData = res.data;
                })
                .catch((err) => {
                    this.tableBusy = false;
                    this.showToast("Something went wrong", "error");
                });
        },
        searchProcurable() {
            this.tableBusy = true;
            this.searchHit = true;
            var data = this.tableData.filter((item) => {
                return item.searchList
                    .toUpperCase()
                    .includes(this.filter.toUpperCase());
            });
            this.searchData = data;
        },
        returnData() {
            if (!this.filter) {
                this.searchHit = false;
            }
        },
        allowPR(row) {
            Swal.fire({
                title: "Are you sure?",
                text: "You want to allow PR without consolidation?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, allow it!",
            }).then(async (result) => {
                if (result.value) {
                    row.prLoading = true;
                    this.$store
                        .dispatch("apiresource/AllowPRMultiple", [row.id])
                        .then((res) => {
                            setTimeout(() => {
                                row.prLoading = false;
                                row.allowPr =
                                    !row.allowPr;
                            }, 500);
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        printAPPByCampus(){
            this.$refs.printOpt.putOptions({apiUrl: 'api/Report/Procurement/APP/Campus', routeVariables: [this.$store.state.data.cycle]})
            this.$bvModal.show('print-options-modal')
        },
        printProcs(){
            this.$refs.printOpt.putOptions({
                apiUrl: 'api/Report/Procurement/Procurable', 
                routeVariables: [this.$store.state.data.selectedCampus.id, this.$store.state.data.cycle]
            })
            this.$bvModal.show('print-options-modal')
        },
        showLogs(id){
            this.$refs.itemlog.getData(id);
            this.$bvModal.show("api-resoure-log-modal");
        },
        getResourceInfo(id){
            this.$refs.resourceDetails.getApiResourceDetails(id);
            this.$bvModal.show("resource-details-modal");
        },
        allowAllPR(row){
            let ids = [];
            row.apiResources.forEach(x => {
                if(!x.isMixed){
                    ids.push(x.id);
                }
            });
            Swal.fire({
                title: "Are you sure?",
                text: "You want to allow all items PR without consolidation?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, allow it!",
            }).then(async (result) => {
                if (result.value) {
                    row.apiResources.forEach(x => x.prLoading = true);
                    this.$store
                        .dispatch("apiresource/AllowPRMultiple", ids)
                        .then((res) => {
                            setTimeout(() => {
                                row.apiResources.forEach(x => {
                                    x.allowPr = true
                                    x.prLoading = false;
                                });
                            }, 500);
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        getApprovedItems(cycle, campusId){
            this.groupedData = [];
            this.tableData = [];
            this.tableBusy = true;
            this.$store
                .dispatch("procurable/GetAllowedProcurableSummary", {
                    cycle,  
                    campusId
                })
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        item.rotateChevy = false;
                        item.searchList = `${item.name}`;
                        item.data = [];
                        item.apiLoading = false;
                    })
                    this.tableBusy = false;
                    this.procurableCount = res.data.length;
                    this.groupedData = res.data;
                    this.tableData = res.data;
                })
                .catch((err) => {
                    this.tableBusy = false;
                    this.showToast("Something went wrong", "error");
                });
        },
        changeStatus(cycle, campusId){
            if(this.procurableStatus == 1){
                this.getInitialItems(cycle, campusId);
            }else if(this.procurableStatus == 2){
                this.getApprovedItems(cycle, campusId);
            }else{
                this.getDUs(campusId);
            }
        },
        printPPMP(id, type){
            if(type == 2){
                this.$refs.printOpt.putOptions({
                    apiUrl: "api/Report/Procurement/PPMP/Api/Report",
                    routeVariables: [id],
                });
            }else{
                this.$refs.printOpt.putOptions({
                    apiUrl: "api/Report/My/PPMP/API",
                    routeVariables: [id],
                });
            }
            this.$bvModal.show("print-options-modal");
        },
        moveToCampusPR(row){
            Swal.fire({
                title: "Are you sure?",
                text: `You want to move this to ${this.GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'} PR?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, move it!",
            }).then(async (result) => {
                if (result.value) {
                    this.$store
                        .dispatch("apiresource/MovePRToCampusMultiple", [row.id])
                        .then((res) => {
                            row.movedToCampus = true;
                            row.addedToCampusPr = true;
                            this.showToast(`Successfully moved to ${this.GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'} PR`, "success");
                        })
                }
            });
        },
        removeCampusPr(row){
            Swal.fire({
                title: "Are you sure?",
                text: `You want to remove this from ${this.GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'} PR?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then(async (result) => {
                if (result.value) {
                    this.$store
                        .dispatch("apiresource/RemoveCampusPR", row.id)
                        .then((res) => {
                            row.addedToCampusPr = false;
                            this.showToast(`Successfully removed to ${this.GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'} PR`, "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        returnToTechRep(x) {
            Swal.fire({
                title: "Are you sure?",
                text: "You want to return to Tech Rep?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, return it!",
            }).then(async (result) => {
                if (result.value) {
                    this.$store
                        .dispatch("apiresource/ResetToTechRep", x.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, 'warning');
                            }
                            x.technicalReviewStatus = "RETURNED";
                            this.showToast('Successfully returned', 'success');
                        })
                        .catch((err) => {
                            this.showToast('Something went wrong!', 'error');
                        });
                }
            });
        },
        async viewApiResource(api){
            api._showDetails = !api._showDetails;
            if(api._showDetails && api.apiResources.length == 0){
                api.apiResourcesLoading = true;
                await this.$store
                    .dispatch("apiresource/GetProcurableApiResource", api.id)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, 'warning');
                        }
                        api.apiResources = res.data;
                    })
                    .catch((err) => {
                        this.showToast('Something went wrong!', 'error');
                    });
                api.apiResourcesLoading = false;
            }
        },
        printPSR(id){
            this.$refs.printOpt.putOptions({
                apiUrl: 'api/Report/Procurement/Status', 
                routeVariables: [id, this.$store.state.data.cycle]
            })
            this.$bvModal.show('print-options-modal')
        },
        getAvailableApis(cycle, row, type){
            row.apiLoading = true;
            let url = type == 'available' ? "procurable/GetDUApi" : "procurable/GetAllowedDUApi";
            this.$store
                .dispatch(url, {cycle, deliveryUnitId: row.id})
                .then((res) => {
                    if(res.data.error){
                        row.apiLoading = false;
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(x => {
                        x._showDetails = false;
                        x.apiResourcesLoading = false;
                        x.apiResources = [];
                    })
                    row.data = res.data;
                    row.apiLoading = false;
                })
                .catch((err) => {
                    row.apiLoading = false;
                    this.showToast("Something went wrong", "error");
                });
        },
        showApi(row) {
            row.rotateChevy = !row.rotateChevy;
            if(this.procurableStatus == 1){
                this.getAvailableApis(this.$store.state.data.cycle, row, 'available');
            }else if(this.procurableStatus == 2){
                this.getAvailableApis(this.$store.state.data.cycle, row, 'approved');
            }
        },
        showApiResources(row){
            row._showDetails = !row._showDetails;
            if(row._showDetails && (!row.apiResources.length || this.procurableStatus == 2)){
                row.apiResourcesLoading = true;
                row.apiResources = [];
                let url = this.procurableStatus == 2 ? 'procurable/GetAllowedApiResources' : 'procurable/GetProcurableApiResources';
                this.$store
                    .dispatch(url, row.id)
                    .then((res) => {
                        if(res.data.error){
                            row.apiResourcesLoading = false;
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        row.apiResources = res.data;
                        row.apiResourcesLoading = false;
                    })
                    .catch((err) => {
                        row.apiResourcesLoading = false;
                        this.showToast("Something went wrong", "error");
                    });
            }
        },
        showIfNotMixed(row){
            let ret = false;
            row.apiResources.forEach(x => {
                if(!x.isMixed){
                    ret = true;
                }
            });
            return ret;
        },
        filteredMix(data){
            let items = data;
            if(this.mixStatus == 1){
                items = data.filter(x => x.isMixed);
            }else if(this.mixStatus == 2){
                items = data.filter(x => !x.isMixed);
            }
            return items;
        }
    },
};
</script>

<template>
    <Layout @changeCycle="changeCycle" @changeCampus="changeCampus($event.id)">
        <PageHeader :title="title" :items="items" />
        <div class="mb-2 d-flex justify-content-between">
            <div class="d-flex">
                <label
                    class="d-inline-flex align-items-center mb-0 me-1"
                >
                    <b-form-input
                        autocomplete="off"
                        v-model.lazy="filter"
                        type="search"
                        :placeholder="`Search Delivery Unit...`"
                        class="form-control"
                        style="width: 300px;"
                    ></b-form-input>
                </label>
                <label class="mb-0 me-1">
                    <select class="form-select" v-model="procurableStatus" @change="changeStatus($store.state.data.cycle, $store.state.data.selectedCampus.id)">
                        <option value="1">Available</option>
                        <option value="2">Approved</option>
                        <option value="3">All</option>
                    </select>
                </label>
                <label class="mb-0">
                    <select class="form-select" v-model="mixStatus" @change="changeStatus($store.state.data.cycle, $store.state.data.selectedCampus.id)">
                        <option value="2">Not Mixed</option>
                        <option value="1">Mixed</option>
                        <option value="3">All</option>
                    </select>
                </label>
            </div>
            <div>
                <button type="button" class="btn btn-purple" @click="printProcs"><i class="bx bx-printer me-1"></i> Print Procurables</button>
            </div>
        </div>
        <div v-if="procurableStatus == 1 || procurableStatus == 2">
            <div v-if="tableBusy">
                <h3>Loading...</h3>
            </div>
            <div v-if="tableData.length == 0 && !tableBusy">
                <h3>No data found...</h3>
            </div>
            <div v-if="!tableBusy && tableData.length > 0">
                <ul>
                    <li
                        v-for="(y, yIndex) in filteredUnallowed"
                        :key="yIndex"
                        class="w-100 mb-2"
                    >
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="d-flex align-items-center">
                                <a
                                    href="javascript:void(0);"
                                    class="font-size-18 text-dark"
                                    @click="showApi(y)"
                                    >{{ y.name }}
                                    <i
                                        class="bx bx-caret-right rotate"
                                        :class="{
                                            'rotate-90': y.rotateChevy,
                                        }"
                                    ></i
                                ></a>
                            </div>
                            <button @click="printPSR(y.id)" type="button" class="btn btn-purple btn-sm" v-if="y.rotateChevy"><i class="bx bx-printer"></i> Procurement Status Report</button>
                        </div>
                        <b-collapse :visible="y.rotateChevy">  
                            <div>
                                <hr>
                                <div class="d-flex justify-content-between align-items-center">
                                    <h5>List of API's</h5>
                                    <a href="javascript:void(0);" class="font-size-20 text-white" @click="y.rotateChevy = false"><i class="bx bx-x"></i></a>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>
                                                API No.
                                            </th>
                                            <th>
                                                API Description
                                            </th>
                                            <th width="220px">
                                                Total Resources
                                            </th>
                                            <th width="150px">
                                                Action
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-if="y.apiLoading">
                                            <tr :key="`apiLoading-y${yIndex}`">
                                                <td colspan="100%" class="text-center">
                                                    Loading...
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <template v-for="w in y.data">
                                                <tr :key="`apiList-y${yIndex}-w${w.id}`">
                                                    <td>
                                                        {{w.apiNumber}}
                                                    </td>
                                                    <td>
                                                        <div>
                                                            <a href="javascript:void(0);" class="text-white" @click="showApiResources(w)">{{w.name}}</a>
                                                        </div>
                                                        <small>
                                                            {{w.description}}
                                                        </small>
                                                        <div v-if="w._showDetails && procurableStatus == 1 && showIfNotMixed(w)">
                                                            <button type="button" class="btn btn-success btn-sm" @click="allowAllPR(w)"><i class="bx bx-check"></i> Allow all items to proceed on PR</button>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {{formatCurrency(w.totalResources)}}
                                                    </td>
                                                    <td>
                                                        <div
                                                            class="
                                                                d-flex
                                                                justify-content-center
                                                                mb-2
                                                            "
                                                        >
                                                            <a
                                                                href="javascript:void(0);"
                                                                @click="showApiResources(w)"
                                                                class="
                                                                    text-white
                                                                    d-flex
                                                                    align-items-center
                                                                "
                                                                ><i
                                                                    class="
                                                                        bx bx-food-menu
                                                                        me-1
                                                                    "
                                                                ></i
                                                                >{{
                                                                    w._showDetails
                                                                        ? "Hide"
                                                                        : "Show"
                                                                }}
                                                                Items</a
                                                            >
                                                        </div>
                                                        <div class="text-center">
                                                            <b-dropdown
                                                                id="dropdown-dropleft"
                                                                right
                                                                variant="purple py-1 btn-sm"
                                                                toggle-class="text-decoration-none"
                                                                menu-class="dropdown-menu"
                                                                no-caret
                                                            >
                                                                <template #button-content>
                                                                    <i class="bx bx-printer me-1"></i>
                                                                    Print PPMP
                                                                </template>
                                                                <b-dropdown-item @click="printPPMP(w.id, 1)">V1</b-dropdown-item>
                                                                <b-dropdown-item @click="printPPMP(w.id, 2)">V2</b-dropdown-item>
                                                            </b-dropdown>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr v-if="w._showDetails" :key="`apiListRrs-y${y.id}-w${w.id}`">
                                                    <td colspan="100%" v-if="w.apiResourcesLoading">
                                                        Loading...
                                                    </td>
                                                    <td colspan="100%" v-else>
                                                        <div v-if="!w.apiResources.length">
                                                            <h4>No data found.</h4>
                                                        </div>
                                                        <template v-else>
                                                            <div v-for="z in filteredMix(w.apiResources)" :key="`resourceList-z${z.id}`" class="ms-3 mb-1 p-3 broken-border" >
                                                                <div class="d-flex align-items-center justify-content-between">
                                                                    <div class="d-flex">
                                                                        <div class="d-flex align-items-center">
                                                                            <div class="font-size-20 text-yellow">
                                                                                {{numberWithCommas(z.quantity)}}
                                                                            </div>
                                                                            <i class="bx bx-x font-size-20 me-2 text-yellow"></i>
                                                                        </div>
                                                                        <div>
                                                                            <div>
                                                                                {{z.itemName}}
                                                                                <div>
                                                                                    <small>{{z.description}}</small>
                                                                                    <small>
                                                                                        <span class="text-warning ms-1" v-if="z.isMixed">[Mixed]</span>
                                                                                        <span class="text-warning ms-1" v-if="z.isProcurable">[Procurable]</span>
                                                                                        <span class="text-warning ms-1" v-else>[Non-procurable]</span>
                                                                                        <a href="javascript:void(0);" title="Show More Details" class="font-size-14 mx-1" @click="getResourceInfo(z.id)">
                                                                                            <i class="bx bx-info-circle align-middle"></i>
                                                                                        </a>
                                                                                        <a href="javascript:void(0);" title="Show Logs" class="font-size-14 me-1 text-green" @click="showLogs(z.id)">
                                                                                            <i class="bx bx-receipt align-middle"></i>
                                                                                        </a>
                                                                                    </small>
                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                                class="
                                                                                    d-flex
                                                                                    align-items-center
                                                                                    mb-1
                                                                                "
                                                                            >
                                                                                <span
                                                                                    class="
                                                                                        badge
                                                                                        bg-secondary
                                                                                        text-white
                                                                                        py-1
                                                                                        px-2
                                                                                        me-1
                                                                                    "
                                                                                    >{{
                                                                                        z
                                                                                            .fundSource
                                                                                    }}</span
                                                                                >
                                                                                <span
                                                                                    class="
                                                                                        badge
                                                                                        bg-purple
                                                                                        text-white
                                                                                        py-1
                                                                                        px-2
                                                                                        me-1
                                                                                    "
                                                                                    >{{
                                                                                        z
                                                                                            .fundClass
                                                                                    }}</span
                                                                                >
                                                                                <span
                                                                                    class="
                                                                                        badge
                                                                                        bg-success
                                                                                        text-white
                                                                                        py-1
                                                                                        px-2
                                                                                        me-1
                                                                                    "
                                                                                    >{{
                                                                                        z
                                                                                            .accountGroup
                                                                                    }}</span
                                                                                >
                                                                                <span
                                                                                    class="
                                                                                        badge
                                                                                        bg-primary
                                                                                        text-white
                                                                                        py-1
                                                                                        px-2
                                                                                    "
                                                                                    >{{
                                                                                        z
                                                                                            .budgetLineItem
                                                                                    }}</span
                                                                                >
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="text-right">
                                                                        <div class="font-size-20 text-yellow mb-0">
                                                                            {{formatCurrency(z.totalWithInflation)}}
                                                                        </div>
                                                                        <div class="mb-2">
                                                                            <small>
                                                                                ({{formatCurrency(z.unitCost)}})
                                                                            </small>
                                                                        </div>
                                                                        <div class="d-flex align-items-center float-end">
                                                                            <!-- <button type="button" class="btn btn-warning btn-sm me-2 no-wrap" @click="returnToTechRep(z)" v-if="z.technicalReviewStatus.toUpperCase() !== 'RETURNED' && procurableStatus == 1">
                                                                                <i class="bx bx-reply-all"></i> Return To Tech Rep
                                                                            </button>
                                                                            <div v-if="z.technicalReviewStatus.toUpperCase() === 'RETURNED' && procurableStatus == 1" class="text-center me-2">
                                                                                <span class="badge bg-warning font-size-12 d-flex align-items-center justify-content-center">
                                                                                    <i class="bx bx-check-double"></i>Returned to Tech Rep
                                                                                </span>
                                                                            </div> -->
                                                                            <button type="button" class="btn btn-success btn-sm me-2 no-wrap" @click="allowPR(z)" v-if="!z.allowPr && !z.addedToCampusPr && !z.isMixed">
                                                                                <span v-if="z.prLoading" class="spinner-border text-dark" style="height:10px;width:10px;"> </span> <span v-else><i class="bx bx-check"></i> Allow PR w/o APP</span>
                                                                            </button>
                                                                            <div v-if="!z.addedToCampusPr && z.allowPr" class="text-center me-2">
                                                                                <span class="badge bg-success font-size-12 d-flex align-items-center justify-content-center">
                                                                                    <i class="bx bx-check-double"></i>Approved
                                                                                </span>
                                                                            </div>
                                                                            <button type="button" class="btn btn-info btn-sm no-wrap" @click="moveToCampusPR(z)" v-if="!z.addedToCampusPr && procurableStatus == 1 && !z.isMixed">
                                                                                <i class="bx bx-check"></i> Move to {{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}} PR
                                                                            </button>
                                                                            <div v-if="z.addedToCampusPr && !z.allowPr && !z.isMixed" class="text-center me-2">
                                                                                <span class="badge bg-warning font-size-12 d-flex align-items-center justify-content-center">
                                                                                    <i class="bx bx-check-double"></i>Moved to {{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}} PR
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </template>
                                                    </td>
                                                </tr>
                                            </template>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </b-collapse>
                    </li>
                </ul>
            </div>
        </div>
        <div v-else>
            <div v-if="tableBusy">
                <h3>Loading...</h3>
            </div>
            <div v-if="dus.length == 0 && !tableBusy">
                <h3>No data found...</h3>
            </div>
            <div v-if="!tableBusy && dus.length > 0">
            </div>
            <ul>
                <li
                    v-for="y in filteredDU"
                    :key="y.id"
                    class="w-100 mb-2"
                >
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center">
                            <a
                                href="javascript:void(0);"
                                class="font-size-18 text-dark"
                                @click="getApis(y)"
                                >{{ y.name }}
                                <i
                                    class="bx bx-caret-right rotate"
                                    :class="{
                                        'rotate-90': y.rotateChevy,
                                    }"
                                ></i
                            ></a>
                        </div>
                        <button @click="printPSR(y.id)" type="button" class="btn btn-purple btn-sm" v-if="y.rotateChevy"><i class="bx bx-printer"></i> Procurement Status Report</button>
                    </div>
                    <b-collapse :visible="y.rotateChevy">  
                        <div v-if="y.loadingApi">
                            Loading...
                        </div>
                        <div v-if="!y.loadingApi && y.apis.length == 0">
                            No data found.
                        </div>
                        <div v-if="!y.loadingApi && y.apis.length > 0">
                            <div>
                                <hr>
                                <div class="d-flex justify-content-between align-items-center">
                                    <h5>List of API's</h5>
                                    <a href="javascript:void(0);" class="font-size-20 text-white" @click="y.rotateChevy = false"><i class="bx bx-x"></i></a>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>
                                                API No.
                                            </th>
                                            <th>
                                                API Description
                                            </th>
                                            <!-- <th width="220px">
                                                Total Resources
                                            </th> -->
                                            <th width="150px">
                                                Action
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="w in y.apis">
                                            <tr :key="`apiList-y${y.id}-w${w.id}`">
                                                <td>
                                                    {{w.apiNumber}}
                                                </td>
                                                <td>
                                                    <div>
                                                        <a href="javascript:void(0);" class="text-white" @click="viewApiResource(w)">{{w.name}}</a>
                                                    </div>
                                                    <small>
                                                        {{w.description}}
                                                    </small>
                                                </td>
                                                <!-- <td>
                                                    {{formatCurrency(w.totalAmt)}}
                                                </td> -->
                                                <td>
                                                    <div
                                                        class="
                                                            d-flex
                                                            justify-content-center
                                                            mb-2
                                                        "
                                                    >
                                                        <a
                                                            href="javascript:void(0);"
                                                            @click="viewApiResource(w)"
                                                            class="
                                                                text-white
                                                                d-flex
                                                                align-items-center
                                                            "
                                                            ><i
                                                                class="
                                                                    bx bx-food-menu
                                                                    me-1
                                                                "
                                                            ></i
                                                            >{{
                                                                w._showDetails
                                                                    ? "Hide"
                                                                    : "Show"
                                                            }}
                                                            Items</a
                                                        >
                                                    </div>
                                                    <div class="text-center">
                                                        <b-dropdown
                                                            id="dropdown-dropleft"
                                                            right
                                                            variant="purple py-1 btn-sm"
                                                            toggle-class="text-decoration-none"
                                                            menu-class="dropdown-menu"
                                                            no-caret
                                                        >
                                                            <template #button-content>
                                                                <i class="bx bx-printer me-1"></i>
                                                                Print PPMP
                                                            </template>
                                                            <b-dropdown-item @click="printPPMP(w.id, 1)">V1</b-dropdown-item>
                                                            <b-dropdown-item @click="printPPMP(w.id, 2)">V2</b-dropdown-item>
                                                        </b-dropdown>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr v-if="w._showDetails" :key="`apiListRrs-y${y.id}-w${w.id}`">
                                                <td colspan="100%" v-if="w.apiResourcesLoading">
                                                    Loading...
                                                </td>
                                                <td colspan="100%" v-if="!w.apiResourcesLoading && w.apiResources.length == 0">
                                                    No data found.
                                                </td>
                                                <td colspan="100%" v-if="!w.apiResourcesLoading && w.apiResources.length > 0">
                                                    <div v-for="z in w.apiResources" :key="`resourceList-z${z.id}`" class="ms-3 mb-1 p-3 broken-border position-relative" >
                                                        <RawData 
                                                            :data="z" 
                                                            v-if="$store.state.decrypt.isAdmin()" 
                                                            placement="left"
                                                            :key="`apiResource-${z.id}`"
                                                        />
                                                        <div class="d-flex align-items-center justify-content-between">
                                                            <div class="d-flex">
                                                                <div class="d-flex align-items-center">
                                                                    <div class="font-size-20 text-yellow">
                                                                        {{numberWithCommas(z.totalQuantity)}}
                                                                    </div>
                                                                    <i class="bx bx-x font-size-20 me-2 text-yellow"></i>
                                                                </div>
                                                                <div>
                                                                    <div>
                                                                        {{z.itemName}}
                                                                        <div>
                                                                            <small>{{z.description}}</small>
                                                                            <small>
                                                                                <span class="text-warning ms-1" v-if="z.isProcurable">[Procurable]</span>
                                                                                <span class="text-warning ms-1" v-else>[{{z.isMixed ? 'Mixed' : 'Non-procurable' }}]</span>
                                                                                <a href="javascript:void(0);" title="Show More Details" class="font-size-14 mx-1" @click="getResourceInfo(z.id)">
                                                                                    <i class="bx bx-info-circle align-middle"></i>
                                                                                </a>
                                                                                <a href="javascript:void(0);" title="Show Logs" class="font-size-14 me-1 text-green" @click="showLogs(z.id)">
                                                                                    <i class="bx bx-receipt align-middle"></i>
                                                                                </a>
                                                                            </small>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="
                                                                            d-flex
                                                                            align-items-center
                                                                            mb-1
                                                                        "
                                                                    >
                                                                        <span
                                                                            class="
                                                                                badge
                                                                                bg-secondary
                                                                                text-white
                                                                                py-1
                                                                                px-2
                                                                                me-1
                                                                            "
                                                                            >{{
                                                                                z
                                                                                    .fundSource
                                                                            }}</span
                                                                        >
                                                                        <span
                                                                            class="
                                                                                badge
                                                                                bg-purple
                                                                                text-white
                                                                                py-1
                                                                                px-2
                                                                                me-1
                                                                            "
                                                                            >{{
                                                                                z
                                                                                    .fundClass
                                                                            }}</span
                                                                        >
                                                                        <span
                                                                            class="
                                                                                badge
                                                                                bg-success
                                                                                text-white
                                                                                py-1
                                                                                px-2
                                                                                me-1
                                                                            "
                                                                            >{{
                                                                                z
                                                                                    .accountGroup
                                                                            }}</span
                                                                        >
                                                                        <span
                                                                            class="
                                                                                badge
                                                                                bg-primary
                                                                                text-white
                                                                                py-1
                                                                                px-2
                                                                            "
                                                                            >{{
                                                                                z
                                                                                    .budgetLineItem
                                                                            }}</span
                                                                        >
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="text-right">
                                                                <div class="font-size-20 text-yellow mb-0">
                                                                    {{formatCurrency(z.totalWithInflation)}}
                                                                </div>
                                                                <div class="mb-2">
                                                                    <small>
                                                                        ({{formatCurrency(z.unitCost)}})
                                                                    </small>
                                                                </div>
                                                                <div v-if="z.allowPr && !z.addedToCampusPr"><a href="javascript:void(0);" class="text-warning hover-underline" @click="moveToCampusPR(z)">Move to Campus PR</a></div>
                                                                <div v-if="z.addedToCampusPr"><a href="javascript:void(0);" class="text-danger hover-underline" @click="removeCampusPr(z)">Remove from Campus PR</a></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </b-collapse>
                </li>
            </ul>
        </div>
        <print-options ref="printOpt"></print-options>
        <api-resource-logs ref="itemlog"></api-resource-logs>
        <ResourceDetails ref="resourceDetails" :showBtn="false"></ResourceDetails>
    </Layout>
</template>